/**
 * Real User Monitoring (RUM) with Web Vitals
 * Tracks Core Web Vitals and sends to analytics endpoint
 */

import { onCLS, onINP, onFCP, onLCP, onTTFB, Metric } from 'web-vitals';

interface WebVitalsMetric {
  name: string;
  value: number;
  rating: 'good' | 'needs-improvement' | 'poor';
  delta: number;
  id: string;
  navigationType: string;
  route: string;
  timestamp: number;
}

function sendToAnalytics(metric: Metric) {
  const body: WebVitalsMetric = {
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    delta: metric.delta,
    id: metric.id,
    navigationType: metric.navigationType,
    route: window.location.pathname,
    timestamp: Date.now(),
  };

  // Use sendBeacon for reliability (survives page unload)
  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
    navigator.sendBeacon('/api/web-vitals', blob);
  } else {
    // Fallback to fetch with keepalive
    fetch('/api/web-vitals', {
      body: JSON.stringify(body),
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch((error) => {
      console.warn('[RUM] Failed to send web vitals:', error);
    });
  }
}

/**
 * Initialize Real User Monitoring
 * Call once in main.tsx for production builds
 */
export function initRUM() {
  // Track Cumulative Layout Shift
  onCLS(sendToAnalytics);
  
  // Track Interaction to Next Paint (replaces FID)
  onINP(sendToAnalytics);
  
  // Track First Contentful Paint
  onFCP(sendToAnalytics);
  
  // Track Largest Contentful Paint
  onLCP(sendToAnalytics);
  
  // Track Time to First Byte
  onTTFB(sendToAnalytics);
  
  console.log('[RUM] Web Vitals monitoring initialized');
}
